import { 
    POST_ROUTE_PREVIEW, 
    POST_ROUTE_PREVIEW_FAIL, 
    POST_ROUTE_PREVIEW_SUCCESS, 
    POST_SAVE_ROUTE, 
    POST_SAVE_ROUTE_FAIL, 
    POST_SAVE_ROUTE_SUCCESS, 
    RESET_ROUTE_PREVIEW,
    POST_ROUTE_PREVIEW_HOPPER, 
    POST_ROUTE_PREVIEW_HOPPER_FAIL, 
    POST_ROUTE_PREVIEW_HOPPER_SUCCESS, 
} from "../actions/types"

const initialState = {
    loading: false,
    error: false,
    routePreview: {
        distance: 0,
        duration: 0,
        usage: 0,
        routes: []
    }
}

export default function rmReducer(state = initialState, action){
    switch(action.type){
        case POST_ROUTE_PREVIEW_HOPPER:
            return {
                ...state,
                loading: true
            }
        case POST_ROUTE_PREVIEW_HOPPER_SUCCESS:
            return {
                ...state,
                loading: false,
                routePreview: action.payload
            }
        case POST_ROUTE_PREVIEW_HOPPER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case POST_ROUTE_PREVIEW:
            return {
                ...state,
                loading: true
            }
        case POST_ROUTE_PREVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                routePreview: action.payload
            }
        case POST_ROUTE_PREVIEW_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case RESET_ROUTE_PREVIEW:
            return {
                ...state,
                routePreview: initialState.routePreview
            }
        case POST_SAVE_ROUTE:
            return {
                ...state,
                loading: true
            }
        case POST_SAVE_ROUTE_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case POST_SAVE_ROUTE_FAIL:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}